export default [
  {
    position: "absolute",
    top: 19,
    left: 32,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "payBenefitsP2.mTitleTwo",
    mBody: "payBenefitsP2.mBodyTwo",
    id: "SP_PayBenefits_Info_Payslips",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 1.1,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "annualCompP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_AnnualCompensation_Navigation_Menu",
    index: 1,
  },
  {
    position: "absolute",
    top: 7.2,
    left: 12.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "payBenefitsP2.ttTextTwo",
    hover: false,
    id: "SP_PayBenefits_Navigation_Communications",
    index: 2,
  },
  {
    position: "absolute",
    top: 7.2,
    left: 43.15,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "payBenefitsP2.ttTextThree",
    hover: false,
    id: "SP_PayBenefits_Navigation_Absence",
    index: 3,
  },
  {
    position: "absolute",
    top: 7.2,
    left: 50.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "payBenefitsP2.ttTextFour",
    hover: false,
    id: "SP_PayBenefits_Navigation_Performance",
    index: 4,
  },
  {
    position: "absolute",
    top: 7.2,
    left: 68.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "payBenefitsP2.ttTextFive",
    hover: false,
    id: "SP_PayBenefits_Navigation_Hiring",
    index: 5,
  },
  {
    position: "absolute",
    top: 5.2,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "payBenefitsP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_PayBenefits_Navigation_TeamMember",
    index: 6,
  },
  {
    position: "absolute",
    top: 53.2,
    left: 89.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "payBenefitsP2.ttTextSeven",
    hover: false,
    id: "SP_PayBenefits_Navigation_AnnualCompensation",
    index: 7,
  },
  {
    position: "absolute",
    top: 45,
    left: 40,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-middle-left",
    isDialog: true,
    modal: false,
    mTitle: "payBenefitsP2.mobilePayslipsTitle",
    mBody: "payBenefitsP2.mobilePayslipsBody",
    isVideo: true,
    videoThumb: "SP-Mobile-Payslips-Thumb",
    videoURL: "SP-Mobile-Payslips.mp4",
    vidIcon: true,
    id: "SP_PayBenefits_Video_Benefits",
    index: 8,
  },
  {
    position: "absolute",
    top: 53,
    left: 2,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-middle-left",
    isDialog: true,
    modal: false,
    mTitle: "payBenefitsP2.personalizedBenefitsTitle",
    mBody: "payBenefitsP2.personalizedBenefitsBody",
    isVideo: true,
    videoThumb: "SP-Personalized-Benefits-Thumb",
    videoURL: "SP-Personalized-Benefits.mp4",
    vidIcon: true,
    id: "SP_PayBenefits_Video_Benefits",
    index: 9,
  },
];
